import { uniqueId } from 'lodash';
import React, { useState } from 'react';
import { Button, Input, Modal, ModalBody, ModalHeader } from 'reactstrap';

const Add_QA_Modal = ({ edit_element,edit_mode, setedit_mode, modal_animationZoom, setmodal_animationZoom,qa_list, setqa_list,question, setquestion , answer, setanswer }) => {
  // const [modal_animationZoom, setmodal_animationZoom] = useState(false);
  


  function tog_qa_animationZoom() {
     setmodal_animationZoom(!modal_animationZoom);
  } 





const onClick_Add_Question_Answer = (e) => {
  let list = qa_list ? qa_list : []

  if(question.length > 0 && answer.length > 0) {
    setqa_list([{
      question,
      answer,
      id:uniqueId()
    },...list])
  
    tog_qa_animationZoom()
  }
     
 

}


const onClick_Update = ()=>{


  // console.log("Updatign");
  
  
  let list = JSON.parse(JSON.stringify(qa_list))
  
  let temp_qa_list = list.map((qa_ele,i)=>{
       
    // console.log(qa_ele);
    // console.log(edit_element);

    if(JSON.stringify(qa_ele) == JSON.stringify(edit_element)){
        
        
        qa_ele.question = question

        qa_ele.answer = answer
       return qa_ele
    }
    else{
      return qa_ele
    }

  })


  setqa_list(temp_qa_list)

  tog_qa_animationZoom()

}


  return (
    <>
      <Button color="secondary" onClick={() => {
        setanswer('')
        setquestion('')
        setedit_mode(false)
        tog_qa_animationZoom()
        }} >create new question set </Button>
      {/* ZoomIn Animation */}
      <Modal id="flipModal" isOpen={modal_animationZoom} toggle={() => { tog_qa_animationZoom(); }} modalClassName="zoomIn modal-lg" centered >
                <ModalHeader className="modal-title" id="flipModalLabel" toggle={() => { tog_qa_animationZoom(); }}>
                
                </ModalHeader>
                <ModalBody>
                    <div className='add_website_link'>
                            <p>Question</p>
                        <textarea value={question}  onChange={(e)=>{
                          setquestion(e.target.value)
                        }}  className="form-control" id="question" rows="3" placeholder=""></textarea>
                    </div>
                    <div className='add_website_link mt-30'>
                            <p>Answer</p>
                        
                        <textarea  value={answer}  onChange={(e)=>{
                          setanswer(e.target.value)
                        }} className="form-control" id="answer" rows="6" placeholder=""></textarea>
                    </div>
                </ModalBody>
                <div className="modal-footer justify-content-center">
                    <Button  className="rounded-pill btn" color="light" onClick={() => { tog_qa_animationZoom(); }}> Cancel </Button>
                    {edit_mode?<Button onClick={onClick_Update}  className="rounded-pill btn" color="secondary" > Update </Button>:
                    <Button onClick={onClick_Add_Question_Answer}  className="rounded-pill btn" color="secondary" > Save </Button>}
                </div>
       </Modal>
    </>
  )
}

export default Add_QA_Modal
